import React from 'react';
import banner1 from "../../assets/subbanner/aerial-shot-beautiful-blue-sea-buildings-mallorca-balearic-islands-spain.jpg";
import banner from "../../assets/banner/aboutimage.jpeg";
import land1 from "../../assets/newservicesimge/r1.jpeg";
import land3 from "../../assets/newservicesimge/r4.jpeg";
import land4 from "../../assets/newservicesimge/r3.jpeg";
import "./realestate.css";

    

function Realestate() {
    return (
        <>
            <section>
                <div className="image-all-banner">
                    <img src={banner1} alt="About Us" className="image-bg-all" />
                    <div className="overlay-all-page">
                        <h2 className="fade-in-text">Real Estate</h2>
                    </div>
                </div>
            </section>

            <section>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Real Estate</h5>
                                    <h3 id="#property-buying">Property Buying & Selling Services:</h3>                                </div>
                                <div className='underline'></div>
                                <p>Navigating the real estate market can be complex, but with our expert buying and selling services, the process becomes smooth, secure, and rewarding. We assist individual buyers, investors, and sellers at every stage—from property search and valuation to negotiation, due diligence, and final registration. Our deep market knowledge and strong network enable us to match buyers with the right properties and help sellers secure the best value for their assets. Whether you're looking for residential homes, commercial spaces, industrial land, or investment properties, we ensure a transparent, hassle-free transaction backed by legal clarity and professional guidance. Our goal is to make property buying and selling a seamless experience with maximum value and minimum risk.</p>
                            </div>
                            <h1> </h1>
                        </div>


                        <div className='col-md-6'>
                            <div className='image-container-right'>
                                <img src={land1} className='image-container-inside' />
                            </div>
                        </div>
                    </div>

                </div>

                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6 order-2  order-md-1'>
                            <div className='image-container-right'>
                                <img src={land3} className='image-container-inside' />
                            </div>

                        </div>


                        <div className='col-md-6 order-1  order-md-2'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Real Estate</h5>
                                    <h3 id="Residential-Commercial">Residential & Commercial Plot Development:</h3>                                </div>
                                <div className='underline'></div>
                                <p>Whether you’re building a dream home or launching a business venture, we provide meticulously planned and legally verified plots that are ready for development. Our plots are located in prime and emerging locations, with clear demarcation, proper road access, and essential infrastructure. We ensure every project meets regulatory standards and urban planning norms, offering investors and homebuyer’s peace of mind and long-term value.</p>
                            </div>

                        </div>
                    </div>

                </div>


                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Real Estate</h5>
                                    <h3 id="Real-Estate">Comprehensive Real Estate Consultancy:</h3>                                </div>
                                <div className='underline'></div>
                                <p>Our consultancy services are designed to guide property buyers, sellers, investors, and developers through every aspect of real estate decisions. We offer insights into market trends, land potential, pricing strategies, investment risks, and regulatory landscapes. Whether you're planning a residential venture or a commercial project, our strategic advice helps you make informed, confident decisions.</p>
                            </div>
                            <h1> </h1>
                        </div>


                        <div className='col-md-6'>
                            <div className='image-container-right'>
                                <img src={land4} className='image-container-inside' />
                            </div>
                        </div>
                    </div>

                </div>


            </section>

        </>
    )
}

export default Realestate;
